import {
  GetMainTopics_URL,
  GetQuestionsByCatID_URL,
  GetSubTopics_URL,
  POST_METHOD,
  ResetHiddenQuestions_URL,
  Submit_Test_Response_URL,
} from '../../Apis/api';

export const getMainTopics = (userId) => {
  return fetch(GetMainTopics_URL, {
    method: POST_METHOD,
    body: JSON.stringify(userId),
  }).then((response) => {
    return response.json();
  });
};

export const getSubTopics = (subTopicRequestBody) => {
  return fetch(GetSubTopics_URL, {
    method: POST_METHOD,
    body: JSON.stringify(subTopicRequestBody),
  }).then((response) => {
    return response.json();
  });
};

export const fetchQuestionByTopicId = (topicId) => {
  return fetch(GetQuestionsByCatID_URL, {
    method: POST_METHOD,
    body: JSON.stringify(topicId),
  }).then((response) => {
    return response.json();
  });
};

export const resetHiddenQuestions_API = (body) => {
  return fetch(ResetHiddenQuestions_URL, {
    method: POST_METHOD,
    body: JSON.stringify(body),
  }).then((response) => {
    return response.json();
  });
};

export const submitTestResponse = (testResponseData) => {
  return fetch(Submit_Test_Response_URL, {
    method: POST_METHOD,
    body: JSON.stringify(testResponseData),
  }).then((response) => {
    return response.json();
  });
};
